<template>
    <BaseForm v-if="series">
        <template #fields>
            <MultiLink
                :label="$t('other-systems')"
                :links="values.otherSystems"
                :error-messages="errors.otherSystems"
                @input="setFieldValue('otherSystems', $event)"
                @delete="setFieldValue('otherSystems', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesSystemsSchema } from '@/project/schemas';
import { computed } from 'vue';

defineProps<{ seriesId: string }>();

const { series, createProjectSeriesMultiLink } = useProjectSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectSeriesMultiLink);

const otherSystemsId = computed(() => series.value?.otherSystems?.id);
const otherSystemsLinks = computed(
    () =>
        series.value?.otherSystems?.links.nodes.map((n) => ({
            ...n,
            multilinkId: otherSystemsId.value,
            status: 'skip' as const,
        })) ?? [],
);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesSystemsSchema,
    computed(() => ({
        otherSystems: getFormFieldLinks(otherSystemsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: otherSystemsId.value, fieldName: 'otherSystems', links: values.value.otherSystems },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
